module.exports = __webpack_public_path__ + "img/ios-home-03.26f8335c.jpg";